import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { TreeItem } from '@mui/x-tree-view'
import { Typography, Radio } from '@mui/material'
import { CvsTextField } from '@components'
import { styled as transientStyled } from '@utils/styleHelpers'

export const FullWidth = styled.div`
  width: 100%;
`
export const NoMarginTypography = styled(Typography)`
  margin-top: 0px;
`
export const TypographyBold = styled(Typography)`
  weight: 500;
`
export const FullWidthTextField = styled(CvsTextField as any)`
  width: 100%;
`

interface ICvsRadioProps {
  semiSelected: boolean
}

export const CvsRadio = transientStyled(Radio)<ICvsRadioProps>(
  ({ semiSelected }) => css`
    & > * {
      color: ${semiSelected ? '#01A166 !important' : 'inherit'};
    }
  `,
)

export const CvsTreeItem = styled(TreeItem)`
  & > .Mui-selected {
    background-color: #fff !important;
    &:hover {
      background-color: #fafafa !important;
    }
  }
`
